import { BRAND } from "../../lib/brand";

export const Legacy = () => {
  return (
    <section
      id="legacy"
      data-testid="legacy-section"
      className="relative py-24 lg:py-36 bg-zinc-50 border-y border-zinc-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 reveal">
          <div className="relative aspect-[4/5] overflow-hidden bg-white border border-zinc-200">
            <img
              src="https://images.unsplash.com/photo-1767786124293-289dafe6340d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
              alt="Silver craftsmanship detail"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="mt-6 flex items-center gap-4">
            <div className="h-16 w-16 border border-zinc-300 grid place-items-center bg-white p-2">
              <img
                src={BRAND.logoUrl}
                alt="GR monogram"
                className="h-full w-full object-contain"
              />
            </div>
            <div>
              <div className="font-display text-lg text-zinc-950">
                Ghisa Ram Khandelwal
              </div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                Saraf · Since 1972 · Chandni Chowk
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 reveal reveal-delay-1">
          <p className="text-[11px] tracking-[0.4em] uppercase text-zinc-500 mb-6">
            02 — The Legacy · Since 1972
          </p>
          <h2 className="font-display font-light text-zinc-950 text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight">
            A family of silversmiths,
            <br />
            <span className="italic text-zinc-600">quietly serving Delhi since 1972.</span>
          </h2>

          <div className="mt-10 space-y-6 text-zinc-700 text-base lg:text-lg leading-relaxed max-w-2xl">
            <p>
              Founded in <strong className="text-zinc-950">1972</strong> in the
              narrow lanes of Kucha Mahajani in old Delhi, Ghisa Ram Khandelwal
              Saraf is a traditional silver jeweller that has served Indian
              families for over five decades. Our shelves hold nothing but{" "}
              <strong className="text-zinc-950">pure silver</strong> — anklets,
              rings, bracelets, neckpieces and temple ornaments, each finished
              by hand.
            </p>
            <p>
              We have never chased trends. Instead, we sit with you, understand
              the occasion, and craft a piece that feels honest — heirlooms
              meant to be passed down, not replaced.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-8 border-t border-zinc-200 pt-10">
            <div>
              <div className="font-display text-3xl text-zinc-950">1972</div>
              <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                Established
              </div>
            </div>
            <div>
              <div className="font-display text-3xl text-zinc-950">Pure</div>
              <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                92.5 Silver
              </div>
            </div>
            <div>
              <div className="font-display text-3xl text-zinc-950">Hand</div>
              <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                Finished
              </div>
            </div>
            <div>
              <div className="font-display text-3xl text-zinc-950">Trust</div>
              <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                Family Jeweller
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
